import type {
  IntentWithoutResponseProps,
  IntentWithResponseProps,
} from '../slots/Intent/Intent.js';

export const isIntentWithResponse = (
  props: IntentWithResponseProps | IntentWithoutResponseProps,
): props is IntentWithResponseProps => {
  return 'onResponse' in props;
};
